import { render, staticRenderFns } from "./single-copy.vue?vue&type=template&id=0da42d62&"
import script from "./single-copy.vue?vue&type=script&lang=js&"
export * from "./single-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports